import { defineComponent } from 'vue'

import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { AddAccessoryForm } from "./add-accessory-form"

export const AddAccessoryModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAddAccessoryForm: AddAccessoryForm
    },
    props: ['movement', 'noCloseImmediately', 'canChainAdd'],
    template: require('./add-accessory-modal.html'),
    data() {
        return {
            shouldChainAdd: false,
            mounted: false,
        }
    },
    methods: {
        open() {
            (this.$refs.modal as any).show()
        },

        close() {
            (this.$refs.modal as any).hide()
        },

        onHide() {
            this.mounted = false
        },

        onShow() {
            this.mounted = true
        },

        onAccessorySelected(event) {
            this.$emit('accessory-selected', event)
            if (this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
                (this.$refs.modal as any).hide()
            }
        },
    },
    watch: {
        mounted(value) {
            this.$emit('mounted', value)
        },
    },
})
